<template>
  <div
    :style="style"
    :class="[`vs-textarea-${color}`, {'textarea-danger': counter ? (value && value.length > counter) : false, 'focusx': isFocus}]"
    class="vs-component vs-con-textarea">

    <h4 v-if="label">
      {{ label }}
    </h4>

    <textarea
      :value="value"
      v-bind="$attrs"
      class="vs-textarea"
      v-on="listeners"
      ref="textarea">
    </textarea>

    <div
      v-if="counter"
      class="count vs-textarea--count">
      {{ value ? value.length : 0 }} / {{ counter }}
    </div>

  </div>
</template>
<script>
    import _color from '@/assets/utils/color.js'

    export default {
        name: 'TextareaAutosize',
        inheritAttrs:false,
        props: {
            value:{},
            autosize: {
                type: Boolean,
                default: true
            },
            label:{
                default:null,
                type: String
            },
            color:{
                default:'primary',
                type:String
            },
            counter:{
                default: null,
                type: [Number, String]
            },
            counterDanger:{
                default: false,
                type: Boolean
            },
        },
        data () {
            return {
                isFocus: false
            }
        },
        computed: {
            style() {
                let style = {}
                style.border = `1px solid ${this.isFocus?_color.getColor(this.color,1):'rgba(0, 0, 0,.2)'}`
                return style
            },
            listeners() {
                return {
                    ...this.$listeners,
                    input:(evt) => {
                        this.$emit('input', evt.target.value)
                    },
                    focus:() => {
                        this.focus()
                    },
                    blur:() => {
                        this.blur()
                    }
                }
            }
        },
        watch: {
            value() {
                if(this.value && this.value.length > this.counter) {
                    this.$emit('update:counterDanger', true)
                } else {
                    this.$emit('update:counterDanger', false)
                }
                // if(this.value.trim() === ''){
                //     this.$refs.textarea.style.height = 'auto'
                // }
            },
        },
        methods: {
            resizeTextarea (event) {
                event.target.style.height = 'auto'
                event.target.style.height = event.target.scrollHeight + 'px'
            },
            focus() {
                this.isFocus = true
                this.$emit('focus')
            },
            blur() {
                this.isFocus = false
                this.$emit('blur')
            }
        },
        beforeDestroy () {
            this.$refs.textarea.removeEventListener('input', this.resizeTextarea)
        },
        mounted () {

            this.$nextTick(() => {
                this.$refs.textarea && this.$refs.textarea.setAttribute('style', 'height: initial;overflow-y:hidden;resize: none !important')
            })

            this.$refs.textarea && this.$refs.textarea.addEventListener('input', this.resizeTextarea)
        }
    }
</script>
